import {
  ApiResponse,
  CancelAudioTranscriptionPostRequest,
  InitOverrideFunction,
  TranscriptionApi,
  TranscriptionTranscribeAudioFilePostRequest,
} from "../../../@api";

export class TranscriptionApiService
  implements Omit<TranscriptionApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: TranscriptionApi) {}

  public transcriptionTranscribeAudioFilePost(
    requestParameters?: TranscriptionTranscribeAudioFilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.transcriptionTranscribeAudioFilePost(requestParameters, initOverrides);
  }

  public transcriptionTranscribeAudioFilePostRaw(
    requestParameters: TranscriptionTranscribeAudioFilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.api.transcriptionTranscribeAudioFilePostRaw(requestParameters, initOverrides);
  }

  public cancelAudioTranscriptionPost(
    requestParameters?: CancelAudioTranscriptionPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.cancelAudioTranscriptionPost(requestParameters, initOverrides);
  }
}
